<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <h2 class="title mb-3">寄稿者一覧</h2>
        <permission-guard situation="contributor_management">
          <v-btn color="primary" dark tile @click="newContributor">
            新規寄稿者追加
          </v-btn>
          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center" style="width: 50px">ID</th>
                  <th class="text-left">アバター</th>
                  <th class="text-left">名前</th>
                  <th class="text-left">肩書き</th>
                  <th class="text-left">編集</th>
                  <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="contributor in contributors" :key="contributor.id">
                  <td class="text-center">
                    {{ contributor.id }}
                  </td>
                  <td>
                    <v-avatar size="40">
                      <img :src="contributor.tmpAvatar.url" />
                    </v-avatar>
                  </td>
                  <td>{{ contributor.name }}</td>
                  <td>{{ contributor.position }}</td>
                  <td>
                    <v-btn
                      color="primary"
                      dark
                      tile
                      @click="editContributor(contributor)"
                    >
                      編集
                    </v-btn>
                  </td>
                  <td>
                    <v-btn
                      v-if="contributor.official"
                      color="teal"
                      small
                      tile
                      class="white--text"
                      @click="contributorOfficialize(contributor.id)"
                    >
                      非公式にする
                    </v-btn>
                    <v-btn
                      v-else
                      color="normal"
                      small
                      tile
                      @click="contributorOfficialize(contributor.id)"
                    >
                      公式にする
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </permission-guard>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title />
        <v-card-text>
          <v-form ref='contributorProfileForm'>
            <v-text-field
              v-model="editableContributor.name"
              style="width: 300px"
              label="寄稿者名"
              :rules="[presenceValidation]"
            >
              <template v-slot:label>
                <InputLabel labelName="寄稿者名" :required="true" />
              </template>
            </v-text-field>
            <v-text-field
              v-model="editableContributor.position"
              style="width: 300px"
              label="肩書き"
            />
            <v-textarea
              v-model="editableContributor.introduction"
              label="プロフィール"
            />
            <ImageFormAndThumbnail
              ref="imageFormAndThumbnail"
              label-name='アバター画像'
              :propsImagePreviewURL="editableContributor.tmpAvatar ? editableContributor.tmpAvatar.url : ''"
              @change-image-file="(value) => editableContributor.tmpAvatar = value"
            ></ImageFormAndThumbnail>
            <profile-links-form
              :profile-links="editableContributor.profileLinks"
              :destroy-profile-links="destroyProfileLinks"
              ref='profileLinksForm'
            />
          </v-form>
          <v-card-actions>
            <v-btn
              v-if="editableContributor.id == null"
              color="green darken-1"
              tile
              dark
              depressed
              @click="createContributor"
            >
              作成する
            </v-btn>
            <v-btn
              v-else
              color="green darken-1"
              tile
              dark
              depressed
              @click="updateContributor"
            >
              更新する
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import PermissionGuard from '@/components/commons/PermissionGuard'
import axios from 'axios'
import headUtilsMixin from '@/mixins/head_utils'
import ProfileLinksForm from '@/components/commons/ProfileLinksForm'
import snakecaseKeys from 'snakecase-keys'
import ImageFormAndThumbnail from '@/components/commons/ImageFormAndThumbnail'
import InputLabel from '@/components/commons/formParts/inputLabel'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  components: {
    PermissionGuard,
    ProfileLinksForm,
    ImageFormAndThumbnail,
    InputLabel
  },
  mixins: [headUtilsMixin, formValidationUtils],
  data: function () {
    return {
      pageTitle: '寄稿者一覧',
      dialog: false,
      contributors: [],
      editableContributor: {
        id: null,
        name: null,
        position: null,
        introduction: null,
        tmpAvatar: null,
        profileLinks: []
      },
      destroyProfileLinks: []
    }
  },
  mounted: function () {
    this.fetchContributor()
  },
  watch: {
    dialog (value) {
      if (value == false) {
        this.editableContributor = {}
        this.$refs.imageFormAndThumbnail.imageFile = null
        this.$refs.imageFormAndThumbnail.imagePreviewURL = null
      }
    }
  },
  methods: {
    fetchContributor () {
      axios.get('/api/contributors').then(
        ({ data }) => {
          data.data.forEach(({ attributes }) =>
            this.contributors.push(attributes)
          )
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.errors
              ? error.response.data.errors.toString()
              : '空白です'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    },
    newContributor () {
      this.editableContributor = {
        id: null,
        name: null,
        position: null,
        introduction: null,
        avatar: null,
        profileLinks: []
      }
      this.contributor = {
        id: null,
        position: null,
        introduction: null,
        avatar: null
      }
      this.dialog = true
    },
    createContributor () {
      if (!this.$refs.contributorProfileForm.validate() || !this.$refs.profileLinksForm.validate()) return false

      const payload = this.editableContributor
      let formData = new FormData()
      formData.append('contributor[name]', payload.name)
      formData.append('contributor[position]', payload.position)
      formData.append('contributor[introduction]', payload.introduction)
      formData.append('contributor[tmp_avatar]', payload.tmpAvatar)
      let arr = snakecaseKeys(payload.profileLinks)
      arr = arr.map(obj => {
        const {_destroy, ...rest} = obj
        return {_destroy: obj.destroy, ...rest}
      })
      formData.append('contributor[profile_links_attributes]', JSON.stringify(arr))
      axios
        .post('/api/contributors', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(
          ({ data }) => {
            const contributor = data.data.attributes
            this.contributors.unshift(contributor)
            this.dialog = false
            const payload = {
              status: 200,
              message: '寄稿者を追加しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.errors
                ? error.response.data.errors.toString()
                : '空白です'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    editContributor (contributor) {
      this.editableContributor = { ...contributor }
      this.dialog = true
    },
    updateContributor () {
      if (!this.$refs.contributorProfileForm.validate() || !this.$refs.profileLinksForm.validate()) return false

      const payload = this.editableContributor
      let formData = new FormData()
      formData.append('contributor[name]', payload.name)
      formData.append('contributor[position]', payload.position)
      formData.append('contributor[introduction]', payload.introduction)
      formData.append('contributor[tmp_avatar]', payload.tmpAvatar)
      const sendProfileLinks = payload.profileLinks.concat(
        this.destroyProfileLinks
      )
      let arr = snakecaseKeys(sendProfileLinks)
      arr = arr.map(obj => {
        const {_destroy, ...rest} = obj
        return {_destroy: obj.destroy, ...rest}
      })
      formData.append('contributor[profile_links_attributes]', JSON.stringify(arr))
      axios
        .patch(`/api/contributors/${payload.id}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(
          ({ data }) => {
            const contributor = data.data.attributes
            Object.assign(
              this.contributors.find((c) => c.id == contributor.id),
              contributor
            )
            this.dialog = false
            const payload = {
              status: 200,
              message: '寄稿者情報を更新しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.errors
                ? error.response.data.errors.toString()
                : '空白です'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    contributorOfficialize (contributorId) {
      axios.patch(`/api/contributor_officialize/${contributorId}`).then(
        ({ data }) => {
          const index = this.contributors.findIndex(
            (v) => v.id === contributorId
          )
          this.contributors.splice(index, 1, data.data.attributes)
          const isOfficial = data.data.attributes.official
          const text = isOfficial ? '公式にしました' : '非公式にしました'
          const payload = {
            status: 200,
            message: text
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.errors.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    }
  }
}
</script>

<style scoped>
th,
td {
  vertical-align: middle;
}
</style>
